<template>
  <div v-if="settings_autoPlayPhotoAudio" style="margin-top: 25px;">
    <b-carousel
      :ref="slideId"
      :id="slideId"
      v-model="slide"
      :interval="settings_interval"
      :controls="controls"
      :indicators="indicators"
      background="#FFFFFF"
      :img-height="viewHeight"
      @sliding-start="handleSlidingStart"
      @sliding-end="handleSlidingEnd"
      :no-touch="true"
      :fade="settingsTransitionStyle"
    >
      <b-carousel-slide
        v-for="(aPhoto, i) in userDataPhotosFinal"
        :name="aPhoto.name"
        :key="i"
      >
        <template #img>
          <photo-card
              :photo="aPhoto"
              :assets-url-home="assetsURLHome"
              :settings_-photo-display="settings_PhotoDisplay"
              :settings_-show-added-by="settings_ShowAddedBy"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
    <resource-nav-bar
      v-if="resource && !settings_hideBottomBar"
      :resource="resource"
      @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <items-sidebar
            :items="userDataPhotosFinal"
            :assets-url-home="assetsURLHome"
            @item-clicked="handleItemClick"
        />
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import ItemsSidebar from "@/components/blockResources/_components/itemsSideBar";
import PhotoCard from "./photoCard";
import DefaultPhotos from "../../assets/json/defaultPhotoAlbum.json";
export default {
  name: "Display_PhotoAlbum",
  mixins: [ResourceBlockDisplay],
  components: {
    PhotoCard,
    ResourceNavBar,
    ItemsSidebar
  },
  props: {},
  created() {},
  mounted() {
    //Pause in case of 1 second to allow audio to load,etc- I think
    this.handleAnyMemoryAdjustments();
    this.handleSlidingEnd(0);
    if(Array.isArray(this.settings_bgSongs) && this.settings_bgSongs.length > 0) {
      this.playInd = 0;
      this.playList = this.settings_bgSongs.map(audio => audio.audioURL);
      this.playRepeat();
    }
  },
  computed: {
    /* SETTINGS */
    settingsTransitionStyle() {
      return this.settings &&
      this.settings.user &&
      this.settings.user.transition
          ? this.settings.user.transition === "fade"
          : true;
    },
    settings_PhotoDisplay() {
      return this.settings && this.settings.user
          ? this.settings.user.photoDisplay
          : "full";
    },
    settings_interval() {
      if (this.pauseSlideWithInterval) return 0;

      return this.settings && this.settings.user && this.settings.user.interval
        ? this.settings.user.interval * 1000
        : 3000;
    },
    settings_bgSongs() {
        return this.settings && this.settings.user && this.settings.user.bgSongs
          ? this.settings.user.bgSongs
          : [];
    },
    settings_hideBottomBar() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._hideBottomBar !== undefined
          ? this.settings.user._hideBottomBar
          : true;
    },
    settings_autoPlayPhotoAudio() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._autoPlayPhotoAudio !== undefined
          ? this.settings.user._autoPlayPhotoAudio
          : true;
    },
    settings_autoPlayCreatedByAudio() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._autoPlayCreatedByAudio !== undefined
        ? this.settings.user._autoPlayCreatedByAudio
        : true;
    },
    settings_isRepeat() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._isRepeat !== undefined
        ? this.settings.user._isRepeat
        : true;
    },
    settings_isShuffle() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._isShuffle !== undefined
        ? this.settings.user._isShuffle
        : true;
    },
    settings_ShowAddedBy() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._addedBy !== undefined
          ? this.settings.user._addedBy
          : false;
    },

    /* DATA */
    userDataPhotos() {
      return this.userData && this.userData.photos
        ? this.userData.photos
        : DefaultPhotos;
    }
  },
  methods: {
    handleAnyMemoryAdjustments(){
      this.userDataPhotosFinal =  this.settings_isShuffle ?
          _.shuffle (this.userDataPhotos):
          this.userDataPhotos;
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidingTo) {
      if (this.settings_autoPlayPhotoAudio) {
        let thePhoto =
            this.userDataPhotosFinal.length > numberSlidingTo
                ? this.userDataPhotosFinal[numberSlidingTo]
                : null;
        if (thePhoto.audio && thePhoto.audio.audioURL) {
          //Pause slide to play using interval
          //The actual pause was not working
          this.pauseSlideWithInterval = true;
          this.handlePlayAudio(thePhoto.audio.audioURL);
        }
      }
    },
    handlePlayAudio(audioURL) {
       this.playerCheckClear();
      this.player = new Audio(audioURL);

      if (this.player) {
        let that = this;
        this.player.addEventListener("ended", (obj)=> {
          this.playerCheckClear();
          this.pauseSlideWithInterval = false;
          this.$refs[this.slideId].next();
          // Proceed to next slide because audio has taken up
          // the interval time
        });
      }
      if (this.player) {
        this.player.play();
      }
    },
    handleItemClick(item) {
      let currentIndexOfItem = Array.isArray(this.userDataPhotosFinal)
          ? this.userDataPhotosFinal.findIndex(x => x.imgURL === item.imgURL)
          : 0;
      //@ToDo keying off the imgURL may or may not be permanent
      //@ToDo, should I require Id for all the item objectss
      this.playInd = currentIndexOfItem;
      this.handleGoToSlideAudioWith(currentIndexOfItem);
      this.handleCloseSideBar();
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleGoToSlideAudioWith(audioInd) {
      this.$refs[this.slideId].setSlide(audioInd);
    }
  },
  data() {
    return {
      userDataPhotosFinal:[],
      DefaultPhotos,  //show a photo with audio
      pauseSlideWithInterval: false,
      assetsURLHome: "", //assets/apps/photoalbum/',
      audioDuration: null,
      sidebarId: "photos-sidebar-1",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "photo-slides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
